// The admin's clinic view toggle, top right next to the theme button.
//
// One click and the server treats this sign-in as a franchisee from the next
// request: navigation, guards, scoping, everything renders exactly as a
// clinic sees it. The button survives the swap because it keys off the real
// role, which the swap never touches, so the way back is one click too.

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { setViewAs } from './api.js'
import { useAuth } from './auth.jsx'
import { ROLE, ACTION, can } from '../../shared/permissions.js'
import { Button } from './components/ui/index.js'

export default function ViewAs() {
  const { user, refresh } = useAuth()
  const navigate = useNavigate()
  const [busy, setBusy] = useState(false)
  const [failure, setFailure] = useState(null)

  if (!user || !can(user.actualRole, ACTION.VIEW_AS)) return null

  const viewing = user.role !== user.actualRole

  async function toggle() {
    setBusy(true)
    setFailure(null)
    try {
      await setViewAs(viewing ? null : ROLE.FRANCHISEE)
      await refresh()
      // Land somewhere both views can open, in case the current page is not
      // part of the view being switched to.
      navigate('/activity')
    } catch (caught) {
      setFailure(caught.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      {failure ? <span className="row-error">{failure}</span> : null}
      <Button variant={viewing ? 'primary' : 'ghost'} onClick={toggle} disabled={busy}>
        {viewing ? 'Back to admin view' : 'Clinic view'}
      </Button>
    </>
  )
}
